import { Component, Input, OnInit } from '@angular/core';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Component({
    selector: 'app-team-certificates',
    templateUrl: './team-certificates.component.html',
    styleUrls: ['./team-certificates.component.scss'],
})
export class TeamCertificatesComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    totalCount: number;

    @Input()
    expiredCount: number;

    @Input()
    horizontalView: boolean;

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {}
}
